import { Component, Input, OnChanges } from '@angular/core';
import { ProductPreviewImage } from '../../models/product-preview.models';

@Component({ selector: 'app-product-image-preview', template: `
  <div class="product-preview" role="group" [attr.aria-label]="productName + ' photos'"
    (keydown.arrowleft)="move(-1, $event)" (keydown.arrowright)="move(1, $event)">
    <div class="preview-image" [style.height]="maxHeight" *ngIf="images[selectedIndex] as image">
      <app-fitness-media-image [mediaId]="image.mediaId" [alt]="image.name || productName"
        [width]="240" [height]="280" maxWidth="100%" [maxHeight]="maxHeight"></app-fitness-media-image>
    </div>
    <div class="preview-thumbnails" *ngIf="images.length > 1">
      <button *ngFor="let image of images; let i = index" type="button" (click)="selectedIndex = i"
        [class.selected]="selectedIndex === i" [attr.aria-pressed]="selectedIndex === i"
        [attr.aria-label]="'View ' + (image.name || productName) + ', image ' + (i + 1) + ' of ' + images.length">
        <app-fitness-media-image [mediaId]="image.mediaId" alt="" [width]="48" [height]="48" maxWidth="40px" maxHeight="40px"></app-fitness-media-image>
      </button>
    </div>
    <span class="preview-count" *ngIf="images.length > 1" aria-live="polite">Image {{selectedIndex + 1}} of {{images.length}}</span>
  </div>`, styles: [`
    :host {display:block; width:100%; max-width:240px;}
    .preview-image {display:flex; align-items:center; justify-content:center;}
    .preview-thumbnails {display:flex; justify-content:center; flex-wrap:wrap; gap:6px; margin-top:10px;}
    button {display:flex; align-items:center; justify-content:center; width:48px; height:48px; padding:3px;
      border:2px solid var(--dw-form-surface-border, #dfdfd7); border-radius:6px; background:var(--dw-form-surface-bg, white); cursor:pointer;}
    button.selected {border-color:var(--dw-form-button-primary-bg, #c41e3a);}
    button:focus-visible {outline:3px solid var(--dw-fitness-countdown-accent, #e9b949); outline-offset:2px;}
    .preview-count {display:block; text-align:center; margin-top:6px; font-size:12px; color:var(--text-secondary, #626975);}
  `] })
export class ProductImagePreviewComponent implements OnChanges {
    @Input() images: ProductPreviewImage[] = [];
    @Input() productName = 'Product';
    @Input() maxHeight = '280px';
    selectedIndex = 0;
    ngOnChanges(): void { this.selectedIndex = 0; }
    move(direction: number, event: KeyboardEvent): void {
        if (this.images.length < 2) return;
        event.preventDefault();
        this.selectedIndex = (this.selectedIndex + direction + this.images.length) % this.images.length;
    }
}
